module.exports = __webpack_public_path__ + "img/next-arrow_s.b89ac1f4.svg";